<template>
  <div class="page1">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px;">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="'标准体系'"/>
      </div>
    </div>
    <div style="width: 1200px;margin: auto;">
      <!--      标准-->
      <el-row style="margin-top: 10px;">
        <el-col style="background-color: #FFFFFF">
          <div>
            <el-col style="margin-top: 20px;width: 360px;margin-left: 20px">
              <div>
                <el-tag style="width: 100%;height: 40px;line-height: 40px">
                  <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{
                    catalogTitle
                  }}</span>
                </el-tag>
              </div>

              <div
                style="font-size:14px;margin-top: 20px;width: 360px;margin-left: 20px;">
                <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
                  <el-tree
                    style="margin-left: -16px"
                    id="standardTree" class="tree"
                    :indent="0"
                    ref="catalogTree" :data="dataList" :props="{label:'name'}" @node-click="showStandardSystemTable"
                    :default-expand-all="true" :expand-on-click-node="false">
                      <span slot-scope="{ node, data }" class="custom-tree-node">
                        <span style="width: 100%">
                          {{ node.label }}<template>
                                    <span>({{ dianji1(data) }})</span>
                                  </template>
                        </span>
                      </span>
                  </el-tree>
                </el-scrollbar>
              </div>
            </el-col>
            <el-col style="margin-left: 20px;margin-top:20px;width: 780px; display: flex;flex-wrap: wrap;gap: 10px;">
              <el-input style="width: 200px;" v-model="Bz100StandardPageQuery.a100" placeholder="请输入标准号"
                        clearable></el-input>
              <el-input style="width: 200px;" v-model="Bz100StandardPageQuery.a298" placeholder="请输入标准中文名"
                        clearable></el-input>

              <el-select v-model="Bz100StandardPageQuery.standardType" placeholder="请选择标准类型" style="width:200px"
                         clearable>
                <el-option value="G" label="国家标准"/>
                <el-option value="C" label="行业标准"/>
                <el-option value="D" label="地方标准"/>
                <el-option value="T" label="团体标准"/>
                <el-option value="N" label="国际国外标准"/>
                <el-option value="J" label="工程标准"/>
                <el-option value="Z" label="技术规范"/>
              </el-select>

              <el-select v-model="Bz100StandardPageQuery.a200" placeholder="请选择标准状态" style="width:200px"
                         clearable>
                <el-option value="在研" label="在研"/>
                <el-option value="现行" label="现行"/>
                <el-option value="废止" label="废止"/>
                <el-option value="未生效" label="未生效"/>
              </el-select>

              <el-date-picker type="daterange" v-model="Bz100StandardPageQuery.publishTimeRange"
                              range-separator="至"
                              start-placeholder="发布开始日期"
                              end-placeholder="发布结束日期"
                              style="width:300px"
                              value-format="yyyy-MM-dd"/>

              <el-button style="height: 40px" type="primary" size="medium" @click="queryBz100StandardPageFun"
                         icon="el-icon-search">查询
              </el-button>
              <!--              <el-button style="height: 40px" type="primary" size="medium" icon="el-icon-back" >-->
              <!--                返回标准体系-->
              <!--              </el-button>-->

              <div style="margin-left:20px;margin-top: 20px;width: 780px">
                <el-scrollbar style="height:calc(100vh - 300px);">
                  <el-table v-loading="loading" :data="Bz100StandardPage.list" row-key="id" border stripe fit
                            style="width: 100%;">
                    <el-table-column label="标准号" prop="name" align="left">
                      <template slot-scope="{row}">
                        <el-button type="text" @click="openDetailStd(row.id)">{{ row.a100 }}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="标准名称" prop="orgName" align="left">
                      <template slot-scope="{row}">
                        <span>{{ row.a298 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="标准类型" prop="standardType" width="110" align="left">
                      <template slot-scope="{row}">
                        <div v-if="row.standardType!=null && row.standardType!=''">
                          <el-tag v-if="row.standardType==G">国家标准</el-tag>
                          <el-tag v-if="row.standardType==C">行业标准</el-tag>
                          <el-tag v-if="row.standardType==D">地方标准</el-tag>
                          <el-tag v-if="row.standardType==T">团体标准</el-tag>
                          <el-tag v-if="row.standardType==N">国际国外标准</el-tag>
                          <el-tag v-if="row.standardType==J">工程标准</el-tag>
                          <el-tag v-if="row.standardType==Z">技术规范</el-tag>
                        </div>
                      </template>
                    </el-table-column>

                    <el-table-column label="发布时间" prop="code" width="100" align="left">
                      <template slot-scope="{row}">
                        <span>{{ row.a101 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="实施时间" prop="sort" width="100" align="left">
                      <template slot-scope="{row}">
                        <span>{{ row.a205 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="页数" prop="abolishTime" width="50" align="left">
                      <template slot-scope="{row}">
                        <span v-if="row.a305 == 0 || row.a305 == null">{{  }}</span>
                        <span v-else>{{ row.a305 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" prop="sort" width="125" align="left">
                      <template slot-scope="{row}">
                        <!--                        <span>{{ row.a205 }}</span>-->
                        <!--                        icon="el-icon-download"-->
                        <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                                   style="padding:7px"
                                   @click="readPDF(row)">预览
                        </el-button>
                        <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                                   style="padding:7px"
                                   @click="downloadPdf(row)">下载
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <pagination :total="Bz100StandardPage.totalRow"
                              :page.sync="Bz100StandardPage.pageNumber"
                              :limit.sync="Bz100StandardPage.pageSize"
                              layout="total, prev, pager, next, jumper"
                              @pagination="queryBz100StandardPage"/>
                </el-scrollbar>
              </div>
            </el-col>
          </div>
          <!--          <br>
                    <div>
                      <div>
                        <el-col
                          style="font-size:14px;margin-top: 20px;width: 360px;margin-left: 20px;">
                          <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
                            <el-tree
                              style="margin-left: -16px"
                              id="standardTree" class="tree"
                              :indent="0"
                              ref="catalogTree" :data="dataList" :props="{label:'name'}" @node-click="showStandardSystemTable"
                              :default-expand-all="true" :expand-on-click-node="false">
                                <span slot-scope="{ node, data }" class="custom-tree-node">
                                  <span style="width: 100%">
                                    {{ node.label }}<template>
                                              <span>({{ dianji1(data) }})</span>
                                            </template>
                                  </span>
                                </span>
                            </el-tree>
                          </el-scrollbar>
                        </el-col>
                        <el-col style="margin-left:20px;margin-top: 20px;width: 780px">
                          <el-scrollbar style="height:calc(100vh - 300px);">
                            <el-table v-loading="loading" :data="Bz100StandardPage.list" row-key="id" border stripe fit
                                      style="width: 100%;">
                              <el-table-column label="标准号" prop="name" align="left">
                                <template slot-scope="{row}">
                                  <el-button type="text" @click="openDetailStd(row.id)">{{ row.a100 }}</el-button>
                                </template>
                              </el-table-column>
                              <el-table-column label="标准名称" prop="orgName" align="left">
                                <template slot-scope="{row}">
                                  <span>{{ row.a298 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column label="标准类型" prop="standardType" width="110" align="left">
                                <template slot-scope="{row}">
                                  <div v-if="row.standardType!=null && row.standardType!=''">
                                    <el-tag v-if="row.standardType==G">国家标准</el-tag>
                                    <el-tag v-if="row.standardType==C">行业标准</el-tag>
                                    <el-tag v-if="row.standardType==D">地方标准</el-tag>
                                    <el-tag v-if="row.standardType==T">团体标准</el-tag>
                                    <el-tag v-if="row.standardType==N">国际国外标准</el-tag>
                                    <el-tag v-if="row.standardType==J">工程标准</el-tag>
                                    <el-tag v-if="row.standardType==Z">技术规范</el-tag>
                                  </div>
                                </template>
                              </el-table-column>

                              <el-table-column label="发布时间" prop="code" width="100" align="left">
                                <template slot-scope="{row}">
                                  <span>{{ row.a101 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column label="实施时间" prop="sort" width="100" align="left">
                                <template slot-scope="{row}">
                                  <span>{{ row.a205 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column label="页数" prop="abolishTime" width="50" align="left">
                                <template slot-scope="{row}">
                                  <span v-if="row.a305 == 0 || row.a305 == null">{{  }}</span>
                                  <span v-else>{{ row.a305 }}</span>
                                </template>
                              </el-table-column>
                              <el-table-column label="操作" prop="sort" width="165" align="left">
                                <template slot-scope="{row}">
                                  &lt;!&ndash;                        <span>{{ row.a205 }}</span>&ndash;&gt;
                                  &lt;!&ndash;                        icon="el-icon-download"&ndash;&gt;
                                  <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                                             @click="readPDF(row.id)">预览
                                  </el-button>
                                  <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                                             @click="readPDF(row.id)">下载
                                  </el-button>
                                </template>
                              </el-table-column>
                            </el-table>
                            <pagination :total="Bz100StandardPage.totalRow"
                                        :page.sync="Bz100StandardPage.pageNumber"
                                        :limit.sync="Bz100StandardPage.pageSize"
                                        layout="total, prev, pager, next, jumper"
                                        @pagination="queryBz100StandardPage"/>
                          </el-scrollbar>
                        </el-col>
                      </div>
                    </div>-->
        </el-col>
      </el-row>
      <description title="标准信息详情" :visible="showDetailStd" width="800px" @close="showDetailFun">
        <description-item label="标准号" v-model="detailStd.a100"></description-item>
        <description-item label="标准名称" v-model="detailStd.a298"></description-item>
        <description-item label="内部标准号" v-model="detailStd.standardNumber"></description-item>
        <description-item label="英文名字" v-model="detailStd.a302"></description-item>
        <description-item label="标准状态">
          <el-tag v-if="detailStd.a200=='1'" type="success">现行</el-tag>
          <el-tag v-if="detailStd.a200=='2'" type="warning">废止</el-tag>
        </description-item>
        <description-item label="标准类型">
          <div v-if="detailStd.standardType!=null && detailStd.standardType!=''">
            <el-tag v-if="detailStd.standardType==G">国家标准</el-tag>
            <el-tag v-if="detailStd.standardType==C">行业标准</el-tag>
            <el-tag v-if="detailStd.standardType==D">地方标准</el-tag>
            <el-tag v-if="detailStd.standardType==T">团体标准</el-tag>
            <el-tag v-if="detailStd.standardType==N">国际国外标准</el-tag>
            <el-tag v-if="detailStd.standardType==J">工程标准</el-tag>
            <el-tag v-if="detailStd.standardType==Z">技术规范</el-tag>
          </div>
        </description-item>
        <description-item label="发布日期" v-model="detailStd.a101"></description-item>
        <description-item label="实施日期" v-model="detailStd.a205"></description-item>
        <description-item label="废止日期" v-model="detailStd.a206"></description-item>
      </description>
      <el-dialog
        title="全文阅读"
        :visible.sync="showReadDialog"
        :before-close="closeReadDialog"
        class="pdfBox"
        fullscreen
        style="background-color: #666666;"
      >
        <el-scrollbar style=" height:100vh;background-color: #666;padding: 0px 0px!important;">
          <div class="content" style="background-color: #666666;width: 880px;margin: auto">
            <div>
              <!--              <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>-->
              <!--              <pdf-->
              <!--                ref="pdf"-->
              <!--                :src="pdgUrl"-->
              <!--                :page="pageNum"-->
              <!--                @progress="loadedRatio = $event"-->
              <!--                @num-pages="pageTotalNum=$event"-->
              <!--              />-->
              <pdf v-if="showReadDialog" style="margin: 5px"
                   ref="pdf"
                   v-for="i in numPages"
                   :key="i"
                   :src="pdgUrl"
                   :page="i"
              ></pdf>
            </div>
          </div>
        </el-scrollbar>
        <!--        <div slot="footer">-->
        <!--          <el-button-group>-->
        <!--            <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>-->
        <!--            <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon&#45;&#45;right" />-->
        <!--            </el-button>-->
        <!--          </el-button-group>-->
        <!--        </div>-->
      </el-dialog>
    </div>
    <loading v-show="pdfLoading"></loading>
  </div>
</template>

<script>
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import NavigationBar from "./compoment/navigationBar";
import description from "../../components/Description/description";
import {loading} from "../../components/Loading";
import descriptionItem from "../../components/Description/descriptionItem";
import request from "../../utils/request";
import Pagination from "../../components/page";
import pdf from 'vue-pdf'

export default {
  name: "system",
  components: {Pagination, NavigationBar, description, descriptionItem, pdf, loading},
  data() {
    return {
      showReadDialog: false,
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      pdgUrl: '',
      G: "G",
      C: "C",
      D: "D",
      T: "T",
      N: "N",
      J: "J",
      Z: 'Z',
      detailStd: {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: '',
        standardType: ''
      },
      showDetailStd: false,
      loading: false,
      pdfLoading: false,
      catalogTitle: '',
      id: '',
      systemName: getSystemName(),
      Bz100StandardPageQuery: {
        catalogId: '',
        pageNumber: 1,
        pageSize: 20,
        a100: '',
        a298: '',
        a200: '',//状态
        publishTimeRange: [],
        beginPublishTime: '',
        endPublishTime: '',
        standardType: '',
        systemId: '',
        belong: getSystemId()
      },
      belong: getSystemId(),
      //标准
      pageSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      dataList: [],
      Bz100StandardPage: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      pageQuerySystem: {
        pageNumber: 1,
        pageSize: 20,
        name: '',
        orgName: '',
        belong: '',
        status: '1'
      },
      numPages: 0
    }
  },
  mounted() {
    this.a1()
    this.getSystemList()

  },
  methods: {
    dianji1(data) {
      // console.log('data', data)
      let dat = data.count != null ? data.count : 0

      if (data.children && data.children.length > 0) {
        dat += this.traversalObject(data.children, dat)
      }
      // console.log('datdatdatdat', dat)
      return dat
    },

    traversalObject(obj, dat) {
      let dataCount = 0
      const _this = this
      obj.forEach(function (item) {
        dataCount = dataCount + item.count
        if (item.children && item.children.length > 0) {
          dataCount += _this.traversalObject(item.children, dat)
        }
      })
      return dataCount
    },
    // http://localhost:8888/attachmentByDir?name=e0c84c0a1b1348f5b274131c1cb76c8d.pdf:新一代标准信息化研究院需求文档V3 (2).pdf&type=projectDocAndPdf
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdgUrl)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    // localUrl0(fileName) {
    //   const _this = this
    //   request({
    //     url: '/attachmentByFileP',
    //     method: 'post',
    //     params: {
    //       name: fileName
    //     },
    //     responseType: 'blob'
    //   }).then(rsp => {
    //     this.pdfLoading = false
    //     let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
    //     _this.pdgUrl = URL.createObjectURL(blob)
    //     // console.log('_this.pdgUrl', _this.pdgUrl)
    //     _this.getNumPages()
    //     _this.showReadDialog = true
    //   }).catch(e => {
    //     this.pdfLoading = false
    //     console.log(e)
    //   })
    // },
    // localUrl(fileName) {
    //   const _this = this
    //   request({
    //     url: '/attachmentByDirP',
    //     method: 'Post',
    //     params: {
    //       name: fileName,
    //       type: 'projectDocAndPdf'
    //     },
    //     responseType: 'blob'
    //   }).then(rsp => {
    //     this.pdfLoading = false
    //     let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
    //     _this.pdgUrl = URL.createObjectURL(blob)
    //     // console.log('_this.pdgUrl', _this.pdgUrl)
    //     _this.getNumPages()
    //     _this.showReadDialog = true
    //   }).catch(e => {
    //     this.pdfLoading = false
    //     console.log(e)
    //   })
    // },
    localUrl0(id, fileName, types) {
      const _this = this
      request({
        url: '/knowledge/attachmentByDir',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileName,
          type: 'projectDocAndPdf',
          types: types
        }
      }).then(rsp => {
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        this.pdfLoading = false
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    localUrl(id, fileName, fileAddress, types) {
      const _this = this
      request({
        url: '/knowledge/attachmentByFile',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileAddress,
          types: types
        }
      }).then(rsp => {
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        this.pdfLoading = false
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    closeReadDialog() {
      // URL.revokeObjectURL(this.pdgUrl)
      this.showReadDialog = false
      this.pageNum = 1
      this.pageTotalNum = 1
      this.loadedRatio = 0
      window.URL.revokeObjectURL(this.pdgUrl)
      this.pdgUrl = ''
    },
    a1() {
      let a1 = getSystemId()
    },
    queryBz100StandardPageFun() {
      this.isQueryStdType = true
      this.Bz100StandardPageQuery.pageNumber = 1
      if (this.Bz100StandardPageQuery.publishTimeRange && this.Bz100StandardPageQuery.publishTimeRange.length === 2) {
        this.Bz100StandardPageQuery.beginPublishTime = this.Bz100StandardPageQuery.publishTimeRange[0]
        this.Bz100StandardPageQuery.endPublishTime = this.Bz100StandardPageQuery.publishTimeRange[1]
      } else {
        this.Bz100StandardPageQuery.beginPublishTime = ''
        this.Bz100StandardPageQuery.endPublishTime = ''
      }
      this.queryBz100StandardPage()
    },
    showStandardSystemTable(data, node) {
      this.Bz100StandardPageQuery.a100 = ''
      this.Bz100StandardPageQuery.a298 = ''
      this.Bz100StandardPageQuery.pageNumber = 1
      this.catalogTitle = data.name
      // if(node.level===1){
      //   this.Bz100StandardPageQuery.catalogId=''
      // }else {
      this.Bz100StandardPageQuery.catalogId = data.id
      // }
      // this.isQueryStdType = false
      this.queryBz100StandardPage()
    },
    async queryBz100StandardPage(data) {
      this.loading = true
      if (data) {
        this.Bz100StandardPageQuery.pageNumber = data.page
        this.Bz100StandardPageQuery.pageSize = data.limit
      }
      if (this.Bz100StandardPageQuery.catalogId != '') {
        await request.post('/portalController/getSearchStdList', this.Bz100StandardPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.Bz100StandardPage = rsp.data
          } else {
            this.$message.error('操作失败')
          }
        })
      } else {
        this.Bz100StandardPageQuery.systemId = this.id
        await request.post('/portalController/queryStandardBySystemId', this.Bz100StandardPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.Bz100StandardPage = rsp.data
          } else {
            this.$message.error('操作失败')
          }
        })
        this.Bz100StandardPageQuery.systemId = ''
      }
      this.loading = false
    },
    // async queryBz100StandardPage(data) {
    //   this.loading = true
    //   if (data) {
    //     this.Bz100StandardPageQuery.pageNumber = data.page
    //     this.Bz100StandardPageQuery.pageSize = data.limit
    //   }
    //   if (this.Bz100StandardPageQuery.catalogId != '') {
    //     await request.post('/portalController/getSearchStdList', this.Bz100StandardPageQuery).then(rsp => {
    //       if (rsp.resultCode === '0') {
    //         this.Bz100StandardPage = rsp.data
    //       } else {
    //         this.$message.error('操作失败')
    //       }
    //     })
    //   } else {
    //     this.Bz100StandardPageQuery.systemId=this.id
    //     await request.post('/portalController/queryStandardBySystemId', this.Bz100StandardPageQuery).then(rsp => {
    //       console.log('bz100', this.Bz100StandardPageQuery)
    //       if (rsp.resultCode === '0') {
    //         this.Bz100StandardPage = rsp.data
    //       } else {
    //         this.$message.error('操作失败')
    //       }
    //     })
    //   }
    // },
    /**
     * 标准体系列表
     */
    getSystemList(data) {
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong = this.belong
      request.post('/portalController/querySystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.id = rsp.data.list[0].id
          this.pageSystem = rsp.data
          this.queryCatalogList(this.id)
          this.queryBz100StandardPage()
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    /**
     * 获取标准目录
     */
    queryCatalogList(id) {
      this.loading = true
      request({
        // url: '/portalController/policyList',
        url: '/portalController/list',
        methods: 'get',
        params: {
          systemId: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.dataList = [{
            id: '',
            name: '标准体系',
            children: rsp.data,
            count: 0
          }]
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    /**
     * 标准查看详情
     * @param id
     */
    openDetailStd(id) {
      request({
        url: '/portalController/getBz100Standard',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {

        if (rsp.resultCode === '0') {
          this.detailStd = rsp.data
          this.showDetailStd = true
        }
      })
    },
    showDetailFun() {
      this.showDetailStd = false
      this.detailStd = {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: '',
        standardType: ''
      }
    },
    readPDF(row) {
      if (!row.fileAddress) {
        let stdNo = row.a100.replace('—', '-')
        window.open('https://openstd.samr.gov.cn/bzgk/std/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=' + encodeURIComponent(stdNo), '_blank')
        return
      }
      const _this = this
      this.pdfLoading = true
      request({
        url: '/portalController/getStandardFileById',
        method: 'get',
        params: {
          id: row.id,
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          _this.standard = rsp.data
          if (_this.standard != null) {
            if (!_this.standard.dowPrivileges || _this.standard.dowPrivileges == null || _this.standard.dowPrivileges == 0) {
              this.pdfLoading = false
              _this.$message.error('暂无权限')
            }
            if (_this.standard.dowPrivileges && _this.standard.dowPrivileges != null && _this.standard.dowPrivileges != 0) {
              if (_this.standard.fileAddress && _this.standard.fileAddress != null && _this.standard.fileAddress != '') {
                if (_this.standard.types != '0') {
                  _this.localUrl0(row.id, _this.standard.fileAddress, 1)
                } else {
                  _this.localUrl(row.id, _this.standard.a100 + '.pdf', _this.standard.fileAddress, 1)
                }

              } else {
                this.pdfLoading = false
                _this.$message.error('暂无文件')
              }

            }
            // this.showBz100StandardDetail = true
          } else {
            this.pdfLoading = false
            _this.$message.error('暂无权限')
            // this.showStandardDetail = true
          }
        } else {
          this.pdfLoading = false
        }
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadPdf(row) {
      if (!row.fileAddress) {
        let stdNo = row.a100.replace('—', '-')
        window.open('https://openstd.samr.gov.cn/bzgk/std/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=' + encodeURIComponent(stdNo), '_blank')
        return
      }
      const _this = this
      this.pdfLoading = true
      request({
        url: '/portalController/getStandardFileById',
        method: 'get',
        params: {
          id: row.id,
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          _this.standard = rsp.data
          if (_this.standard != null) {
            if (_this.standard.quota == 0) {
              _this.pdfLoading = false
              _this.$message.error('当前系统下载数量超过限额')
              return
            }
            /* if (!_this.standard.dowPrivileges || _this.standard.dowPrivileges == null || (_this.standard.dowPrivileges != 2 && _this.standard.dowPrivileges != 3)) {
              this.pdfLoading = false
              _this.$message.error('没有下载权限')
              return
            }*/
            // if (_this.standard.dowPrivileges && _this.standard.dowPrivileges != null && (_this.standard.dowPrivileges == 2 || _this.standard.dowPrivileges == 3)) {
            if (_this.standard.fileAddress && _this.standard.fileAddress != null && _this.standard.fileAddress != '') {
              if (_this.standard.types != '0') {
                _this.downloadFun(row.id, _this.standard.fileAddress, 0)
              } else {
                _this.downloadFunBy1(row.id, _this.standard.a100 + '.pdf', _this.standard.fileAddress, 0)
              }
            } else {
              _this.pdfLoading = false
              _this.$message.error('暂无文件')
            }
          } else {
            this.pdfLoading = false
            _this.$message.error('暂无权限')
            // this.showStandardDetail = true
          }
        } else {
          this.pdfLoading = false
        }
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadFun(id, fileName, types) {
      let list = []
      if (fileName && fileName != '') {
        list = fileName.split(':')
      }
      request({
        url: '/knowledge/attachmentByDir',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileName,
          type: 'projectDocAndPdf',
          types: types
        }
      }).then(rsp => {
        this.pdfLoading = false
        const blob = new Blob([rsp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = window.URL.createObjectURL(blob)
        link.download = list[1]
        link.click()
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadFunBy1(id, fileName, fileAddress, types) {
      request({
        url: '/knowledge/attachmentByFile',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileAddress,
          types: types
        }
      }).then(rsp => {
        this.pdfLoading = false
        const blob = new Blob([rsp.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
  }
}
</script>
<style scoped>
.right {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABtUlEQVRYhcXWz0vCYBgH8O/UpEDSOoSXAvUQBHULQggCCapLtzpE525douhSWpf6A+pUEESXDhIU0bVTUFF0EekHClFCMQUNNXVlLDLcnL7v3LvtuWx7373v++HZu2fjHLeBEIAgTAoLABGwZiYAZiIsVeemICyya8MRcoDhCKt9zqvUfg6AAzDCaqGBNh9u+vZQLJdwlY3+tytloBLMMtFt70LYtwGn1YHMV07S1wgAtYgDTxBL7hlJm7jokW8T7pZO7PDH2E+eSfptFPOG/o7EYuV39GPSNYyUkMEufwI7Z8Ohdx29rT04TV9g8WWrZky9PSAPqj1xmY1gqiOACZcfd/lHLLtnMeYcwnU2iunYCoploWaMWIppAJUglm0xA/ue1V8tBw6xwisCD/PghbTi/bQZqAQxE/efz/j4zmG0fRBJIY3xpwUkSnzdCWn2gDyIe2L7PYy3UgqRfBzxQqLhZGofQXUw+YqSXkMSQHOd0AJggtAK0IxgAdCEYAVoGsES0BSCNUA1Qg+AKoReAGqEngAqhN4AIsIIQEOEUYC6CCMBigijATUIMwASRDN/ROwQAH4AFix1WZqCV78AAAAASUVORK5CYII=");
  background-position: 100% 0%;
  background-size: 16px;
  background-repeat: no-repeat;
}

.wrong {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABkUlEQVRYhcXVv44BQRwH8O+M3YSCREQiGoXCn0ql0YhaiVKl8gbI5dwzKHVEgWIjask9gJB4AA+gpHG5tXPhmmVZszv751ftzM5MPrvfzW/JTzLZB/AJn4oCuAK+/ATATwTVXfuCoA9jzxGPAM8RzwC2EbRahbzdgpZK9zdiMciKAmkw4AbYQrD9HiQUgjQagVYqtzkSj0OezUCKRbDdzrDn2gfenWupT5B8HvJ0CkQiUHs9BNptkFQKl34fl+HQFsA6IpuFNJmAJBKApkHtdqGNx0/XmkXwCOCPgzHzsa4CH+Ew77Hf14cDUDZbRHI5yPM5SDQKtdMByWQQqNWA4xFssxECvEXc8lcUIBiE2mpBWyzAlkvQchm0XgdOJwOCNwJ9vYyDpNNg5zPUZhPaanWbY4cDfhsNsPUapFAw7uH8CF9BhP+idt6AHiDcMUUAjiBEAcIIJwBCCKcAthFOAmwhnAZYRrgBsIRwC8CNcBPAhXAb8BbhBcAU4RXgJcJLwFOE1wADwg/AHULyCfCPAPAHqPFvXhI80B0AAAAASUVORK5CYII=");
  background-position: 100% 0%;
  background-size: 16px;
  background-repeat: no-repeat;
}
</style>

<style>
.pdfBox {
  padding: 0 0 !important;
}

.pdfBox .el-dialog__body {
  padding: 0px 0px;
  background-color: #666666 !important;
}

.el-tree-node__content {
  font-size: 14px !important;
}

.el-tabs__item.is-left {
  width: 150px;
  height: 55px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  text-align: center !important;
  line-height: 55px;
}

.page1 .el-scrollbar__wrap {
  overflow-x: hidden;
}

.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

/*//有子节点 且未展开*/
.el-tree .el-icon-caret-right:before {
  background: url('../../../src/assets/image/folder.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//有子节点 且已展开*/
.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url('../../../src/assets/image/open.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//没有子节点*/
.el-tree .el-tree-node__expand-icon.is-leaf::before {
  background: url('../../../src/assets/image/file.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}
</style>
<style scoped>
.newsContent h1, .newsContent p {
  text-align: center;
}

.newsContent p {
  color: #666;
}

.newsContent div {
  padding: 20px 10px;
}

.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px solid #d1d2d3;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px solid #d1d2d3;
  height: 20px;
  top: 12px;
  width: 24px;
}

.tree-container {
}

.page1 {
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size: 100% 775px;
}

>>> .el-tabs__nav .el-tabs__item:hover {
  color: #ffffff;
  background-color: #004e96;
}

>>> .el-tabs__nav .el-tabs__item.is-active {
  color: #ffffff;
  background-color: #004e96;
}

>>> .el-tabs__nav .el-tabs__item {
  color: #000000;
  background-color: #FFFFFF;
}
</style>




// WEBPACK FOOTER //
// src/views/home/system.vue